// CANONICAL COPY (GH #7115). src/constants/obligations/obl-supporting-utilities.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-supporting-utilities',
  title: 'Verify protection of supporting utilities',
  description:
    'Confirm that information processing facilities are protected from power failures and other disruptions caused by failures in supporting utilities — electricity, telecommunications, water supply, gas, sewage, ventilation and air-conditioning. Controls shall include multiple-source power where appropriate, uninterruptible power supplies, backup generators with regular test cycles, emergency switches, and alarms for utility malfunction. Review utility dependency register and test / inspection records.',
  category: 'assets',
  scfIds: ['SCF-PHY-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Supporting utilities standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
